import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 0
  });
  const totalSpots = 200;
  const [spotsLeft, setSpotsLeft] = useState(17); // Start with a low number to create urgency
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    // Occasionally decrease spots left
    const spotsTimer = setInterval(() => {
      setSpotsLeft(prev => prev > 3 ? prev - 1 : prev);
    }, 45000);
    return () => {
      clearInterval(timer);
      clearInterval(spotsTimer);
    };
  }, []);
  const progressPercentage = (totalSpots - spotsLeft) / totalSpots * 100;
  return <div className="w-full max-w-md mx-auto bg-red-50 border border-red-200 rounded-xl p-4 my-4 shadow-sm" data-id="element-37" data-mp="123ak9dlggjdq">
      <div className="text-center mb-3" data-id="element-38" data-mp="172n5xv0lbkeq">
        <h3 className="text-red-600 font-bold text-base mb-0.5" data-id="element-39" data-mp="173ojq78zql05">
          ¡OFERTA POR TIEMPO LIMITADO!
        </h3>
        <p className="text-gray-700 text-xs" data-id="element-40" data-mp="1zq9ivtvpk1e9">
          Los bonos gratuitos desaparecen en:
        </p>
      </div>

      <div className="flex justify-center items-start gap-3 mb-4" data-id="element-41" data-mp="1l1wm4uosqeip">
        <div className="flex flex-col items-center" data-id="element-42" data-mp="1kzismq9rlad9">
          <div className="bg-white text-red-600 font-black text-2xl w-12 h-12 flex items-center justify-center rounded-lg shadow-sm border border-red-100" data-id="element-43" data-mp="1pzem3vku5jek">
            {String(timeLeft.hours).padStart(2, '0')}
          </div>
          <span className="text-[10px] text-gray-500 mt-1 uppercase font-bold" data-id="element-44" data-mp="2ii20ks5bu06o">
            Horas
          </span>
        </div>
        <div className="text-red-600 font-black text-2xl mt-2.5" data-id="element-45" data-mp="2ndmx6sn6giyl">:</div>
        <div className="flex flex-col items-center" data-id="element-46" data-mp="2neftezoifq2h">
          <div className="bg-white text-red-600 font-black text-2xl w-12 h-12 flex items-center justify-center rounded-lg shadow-sm border border-red-100" data-id="element-47" data-mp="2jbjfvndtuk5e">
            {String(timeLeft.minutes).padStart(2, '0')}
          </div>
          <span className="text-[10px] text-gray-500 mt-1 uppercase font-bold" data-id="element-48" data-mp="29en51b0ghlxo">
            Min
          </span>
        </div>
        <div className="text-red-600 font-black text-2xl mt-2.5" data-id="element-49" data-mp="24l28lneih00l">:</div>
        <div className="flex flex-col items-center" data-id="element-50" data-mp="1zov7q90z2epi">
          <div className="bg-white text-red-600 font-black text-2xl w-12 h-12 flex items-center justify-center rounded-lg shadow-sm border border-red-100" data-id="element-51" data-mp="1vmqidmhk448o">
            {String(timeLeft.seconds).padStart(2, '0')}
          </div>
          <span className="text-[10px] text-gray-500 mt-1 uppercase font-bold" data-id="element-52" data-mp="1lpc2bnzjphgw">
            Seg
          </span>
        </div>
      </div>

      <div className="space-y-1.5" data-id="element-53" data-mp="18cohzn5978f">
        <div className="flex justify-between text-xs font-bold text-gray-700" data-id="element-54" data-mp="6536isiiecwh">
          <span data-id="element-55" data-mp="b4g15zfmgo9m">Cupos disponibles:</span>
          <span className="text-red-600" data-id="element-56" data-mp="b5hc83wn1arc">
            {spotsLeft} de {totalSpots}
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden" data-id="element-57" data-mp="f4q7xeb8nipj">
          <div className="bg-red-600 h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
          width: `${progressPercentage}%`
        }} data-id="element-58" data-mp="3elxxpapy28uq"></div>
        </div>
        <p className="text-[11px] text-center text-gray-500" data-id="element-59" data-mp="3nl1iqk8o8ybv">
          Más del 90% de los cupos con bonos ya fueron reclamados
        </p>
      </div>
    </div>;
}